import { render, staticRenderFns } from "./GessiLogo.vue?vue&type=template&id=60bb896a&scoped=true&"
var script = {}
import style0 from "./GessiLogo.vue?vue&type=style&index=0&id=60bb896a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bb896a",
  null
  
)

export default component.exports